import type { ReactNode } from 'react';
import styles from './FilterList.module.scss';

interface FilterListProps {
  children: ReactNode;
  ariaLabel?: string;
}

const FilterList = ({ children, ariaLabel }: FilterListProps) => (
  <div className={styles.wrapper}>
    <ul className={styles.list} aria-label={ariaLabel}>
      {children}
    </ul>
  </div>
);

interface FilterListItemProps {
  children: ReactNode;
}

const FilterListItem = ({ children }: FilterListItemProps) => (
  <li className={styles.item}>{children}</li>
);

FilterList.Item = FilterListItem;

export default FilterList;
